<template>
  <qx-card-form title="借支信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="order" slot-scope="prop">
        <ChooseOrder
          slot="order"
          :isRadio="true"
          v-model="prop.form.order"
          @change="handleOrderChange"
        />
      </section>
      <span slot="weightUnit" class="unit">kg</span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import ChooseOrder from 'components/choose/order';
export default {
  components: {
    ChooseOrder,
  },
  data () {
    return {
      baseForm: {
        loanSubjectOptions: [], // 借支类型
        isNeedBillOptions: [], // 借支票据
        form: [
          {
            label: '借支类型',
            value: 'loanSubject',
            type: 'select',
            onChange: () => {
              this.handleTypeChange();
            },
          },
          {
            label: '过磅重量',
            value: 'weight',
            type: 'input',
            hide: true,
          },
          {
            label: '借支金额',
            value: 'amount',
            type: 'input',
          },
          {
            label: '订单号码',
            value: 'order',
            slot: true,
            default: {},
          },
          {
            label: '司机姓名',
            value: 'carOwnerName',
            type: 'input',
            disabled: true,
          },
          {
            label: '司机手机',
            value: 'carPhone',
            type: 'input',
            disabled: true,
          },
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
          },
          {
            label: '借支票据',
            value: 'isNeedBill',
            type: 'select',
          },
          {
            label: '借款说明',
            value: 'appReason',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '上传附件',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: {
          loanSubject: [ // 借支类型
            { required: true, message: '请选择借支类型', trigger: 'blur' },
          ],
          weight: [ // 过磅重量
            { required: true, message: '请输入过磅重量', trigger: 'blur' },
          ],
          amount: [ // 借支金额
            { required: true, message: '请输入借支金额', trigger: 'blur' },
          ],
          order: [ // 订单号码
            { required: false, message: '请选择订单', trigger: 'blur' },
          ],
          isNeedBill: [ // 借支票据
            { required: true, message: '请选择借支票据', trigger: 'blur' },
          ],
          appReason: [ // 借款说明
            { required: true, message: '请输入借款说明', trigger: 'blur' },
          ],
          file: [ // 上传附件
            { required: true, message: '请选择上传附件', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handleTypeChange () {
      const loanSubject = this.$refs.baseForm.getVal('loanSubject');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: loanSubject !== '4',
        names: ['weight'],
      });
      this.$emit('getOtherFormVal', {
        from: 'insurance',
        tar: 'baseForm',
      });
      this.$emit('getOtherFormVal', {
        from: 'other',
        tar: 'baseForm',
      });
    },

    handleOrderChange (data) {
      this.$refs.baseForm.setVal('carOwnerName', data.carDriverMan); // 司机姓名
      this.$refs.baseForm.setVal('carPhone', data.carDriverPhone); // 司机手机
      this.$refs.baseForm.setVal('plateNumber', data.plateNumber); // 车牌号
    },

    async setList (enumsList) {
      this.baseForm.loanSubjectOptions = enumsList[0];
      this.baseForm.isNeedBillOptions = enumsList[1];
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.order) { // 订单
          formData.orderId = formData.order.orderId;
          delete formData.order;
        }
      }
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.classify = 2;
        if (formData.file) { // 附件
          formData.fileId = formData.file.map((item) => item.id).join(',');
          // formData.fileUrl = formData.file.map((item) => item.url).join(',');
          delete formData.file;
        }
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      if (formData.file) { // 附件
        formData.fileUrl = JSON.parse(JSON.stringify(formData.file));
        formData.fileId = formData.file.map((item) => item.id).join(',');
        // formData.fileUrl = formData.file.map((item) => item.url).join(',');
        delete formData.file;
      }
      return formData;
    },
    async init (data = {}) {
      if (data.loanSubject) { // 借支类型
        data.loanSubject = String(data.loanSubject);
      }
      if (data.isNeedBill !== null && data.isNeedBill !== undefined) { // 借支票据
        data.isNeedBill = String(data.isNeedBill);
      }
      if (data.amountDouble) {
        data.amount = data.amountDouble;
      }
      data.file = [];
      if (data.fileId) {
        const ids = data.fileId;
        const urls = data.fileUrl;
        urls.forEach((url, index) => {
          data.file.push({
            id: ids[index],
            url,
          });
        });
      }
      if (data.orderId) {
        data.order = {
          orderId: data.orderId,
          carDriverMan: data.carOwnerName,
          carDriverPhone: data.carPhone,
          plateNumber: data.plateNumber,
        };
      } else {
        data.order = {};
      }

      this.$refs.baseForm.setVal('form', data);
      this.handleTypeChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
